// extracted by mini-css-extract-plugin
module.exports = {"table":"RelatedApplicationsTable_table__3MgGl","totalColumnHeadCell":"RelatedApplicationsTable_totalColumnHeadCell__1CC9k"};